import { IBaseSobFinancialData } from 'partner360/models/financialTable/baseSobFinancialData'

import { getRecalculatedYoYAndQoQFields } from './getRecalculatedYoYAndQoQFields'

interface IGetRecalculatedOther<T extends IBaseSobFinancialData> {
  data: T[]
}

export const getRecalculatedYoYAndQoQ = <T extends IBaseSobFinancialData>({
  data,
}: IGetRecalculatedOther<T>): T[] => {
  return data.map((item) => {
    const calckedYoYAndQoQFields = getRecalculatedYoYAndQoQFields<T>({
      item,
    })

    return { ...item, ...calckedYoYAndQoQFields }
  }, [])
}
